<template>
  <FormWrapper hideNavBar>
    <div class="text-center">
      <div class="text-5xl">
        🎉
      </div>
      <h1 class="mt-6 text-2xl">
        Thank you for your interest in Elective!
      </h1>
    </div>
    <div class="my-6">
      <p>
        Please check your inbox for an email from us with details about this decision.
        We're constantly working on way to expand opportunities to work with businesses like yours,
        so we encourage you to check back again in the future.
      </p>

      <p class="mt-4">
        Have any questions? We’re available at <HelpEmailLink />
      </p>
    </div>
    <a
      href="https://elective.com"
      class="block text-center btn btn-secondary"
    >
      Back to Elective
    </a>
  </FormWrapper>
</template>

<script setup lang="ts">
import FormWrapper from '@/components/form_wrapper.vue';
import HelpEmailLink from '@/components/help_email_link.vue';
</script>
